import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import areaService from "@/services/area";

export const useAreasStore = defineStore("areas", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchParentAreas(payload) {
    loading.value = true;
    try {
      const res = await areaService.getParentAreas(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchAllAreas(payload) {
    loading.value = true;
    try {
      const res = await areaService.getAllAreas(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addArea(payload) {
    loading.value = true;
    try {
      const res = await areaService.addArea(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editArea(payload) {
    loading.value = true;
    try {
      const res = await areaService.editArea(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteArea(payload) {
    loading.value = true;
    try {
      const res = await areaService.deleteArea(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function moveArea(payload) {
    loading.value = true;
    try {
      const res = await areaService.moveArea(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchAreasBySearch(payload) {
    loading.value = true;
    try {
      const res = await areaService.getAreasBySearch(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchParentAreas,
    fetchAllAreas,
    fetchAreasBySearch,
    addArea,
    editArea,
    deleteArea,
    moveArea,
  };
});
